<template>
  <PageTemplate>
    <div class="row">
      <div class="col-md-12 ">
        <h1>Terms and Conditions</h1>
      </div>
      <div
        class="col-md-12 "
        v-html="termsAndConditions"
      />
    </div>
  </PageTemplate>
</template>
<script>
  import PageTemplate from "@/templates/Page";
  import {buildBreadCrumb} from "@/common/tableFunctions";
  import htmlConstants from "@/common/htmlConstants";
  import routes from "@/common/routes";

  export default {
    name: "TermsAndConditions",
    components: {
      PageTemplate,
    },
    data: () => ({
        termsAndConditions: htmlConstants.TERMS_AND_CONDITIONS,
    }),
    mounted() {
      this.updateBreadCrumb();
    },
    methods: {
      updateBreadCrumb: function () {
        let breadcrumbs = [];
        breadcrumbs['Dashboard'] = routes.DASHBOARD;
        breadcrumbs['Terms and Conditions'] = '';
        this.$store.dispatch('updateBreadCrumbAction', buildBreadCrumb(breadcrumbs));
      }
    }
  }
</script>